import { useState } from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="bg-gray-900 z-20 sticky top-0">
      <div className="px-4 py-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
        <div className="relative flex items-center justify-between">
          <NavLink
            to="/"
            aria-label="Code Quiz"
            title="Code Quiz"
            className="inline-flex items-center"
          >
            <svg
              className="w-8 text-green-400"
              viewBox="0 0 24 24"
              strokeLinejoin="round"
              strokeWidth="2"
              strokeLinecap="round"
              strokeMiterlimit="10"
              stroke="currentColor"
              fill="none"
            >
              <rect x="3" y="1" width="7" height="12" />
              <rect x="3" y="17" width="7" height="6" />
              <rect x="14" y="1" width="7" height="6" />
              <rect x="14" y="11" width="7" height="12" />
            </svg>
            <span className="ml-1 text-2xl font-bold tracking-wide text-gray-100 uppercase">
              Code <span className="text-yellow-500">Quiz</span>
            </span>
          </NavLink>

          <ul className=" items-center hidden space-x-8 lg:flex">
            <li>
              <NavLink
                to="/home"
                aria-label="Home"
                title="Home"
                className={({ isActive }) =>
                  isActive
                    ? "font-medium tracking-wide text-blue-400 transition-colors duration-200 hover:bg-yellow-400 hover:text-black p-1 rounded"
                    : "font-medium tracking-wide text-white transition-colors duration-200 hover:bg-yellow-400 hover:text-black p-1 rounded"
                }
              >
                Home
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/statistics"
                aria-label="Statistics"
                title="Statistics"
                className={({ isActive }) =>
                  isActive
                    ? "font-medium tracking-wide text-blue-400 transition-colors duration-200 hover:bg-yellow-400 hover:text-black p-1 rounded"
                    : "font-medium tracking-wide text-white transition-colors duration-200 hover:bg-yellow-400 hover:text-black p-1 rounded"
                }
              >
                Statistics
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/blog"
                aria-label="Blog"
                title="Blog"
                className={({ isActive }) =>
                  isActive
                    ? "font-medium tracking-wide text-blue-400 transition-colors duration-200 hover:bg-yellow-400 hover:text-black p-1 rounded"
                    : "font-medium tracking-wide text-white transition-colors duration-200 hover:bg-yellow-400 hover:text-black p-1 rounded"
                }
              >
                Blog
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/about"
                aria-label="About"
                title="About Us"
                className={({ isActive }) =>
                  isActive
                    ? "font-medium tracking-wide text-blue-400 transition-colors duration-200 hover:bg-yellow-400 hover:text-black p-1 rounded"
                    : "font-medium tracking-wide text-white transition-colors duration-200 hover:bg-yellow-400 hover:text-black p-1 rounded"
                }
              >
                About Us
              </NavLink>
            </li>
          </ul>
          <div className="lg:hidden z-20">
            <button
              aria-label="Open Menu"
              title="Open Menu"
              className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline"
              onClick={() => setIsMenuOpen(true)}
            >
              <svg className="w-5 text-blue-600" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                />
                <path
                  fill="currentColor"
                  d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                />
                <path
                  fill="currentColor"
                  d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                />
              </svg>
            </button>
            {isMenuOpen && (
              <div className="absolute top-0 left-0 w-full z-20">
                <div className="p-5 bg-gray-700 rounded shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <NavLink
                        to="/"
                        aria-label="Logo"
                        title="Logo"
                        className="inline-flex items-center"
                      >
                        <svg
                          className="w-8 text-blue-500"
                          viewBox="0 0 24 24"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeMiterlimit="10"
                          stroke="currentColor"
                          fill="none"
                        >
                          <rect x="3" y="1" width="7" height="12" />
                          <rect x="3" y="17" width="7" height="6" />
                          <rect x="14" y="1" width="7" height="6" />
                          <rect x="14" y="11" width="7" height="12" />
                        </svg>
                        <span className="ml-1 text-2xl font-bold tracking-wide text-green-500 uppercase">
                          Code <span className="text-yellow-500">Quiz</span>
                        </span>
                      </NavLink>
                    </div>
                    <div>
                      <button
                        aria-label="Close Menu"
                        title="Close Menu"
                        className="p-2 -mt-2 bg-gray-500 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <nav>
                    <ul className="space-y-4 bg-gray-400 rounded pl-2">
                      <li>
                        <NavLink
                          to="/home"
                          aria-label="Home"
                          title="Home"
                          className={({ isActive }) =>
                            isActive
                              ? "font-medium tracking-wide text-blue-700 transition-colors duration-200 hover:text-red-500"
                              : "font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-red-500"
                          }
                        >
                          Home
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          to="/statistics"
                          aria-label="Statistics"
                          title="Statistics"
                          className={({ isActive }) =>
                            isActive
                              ? "font-medium tracking-wide text-blue-700 transition-colors duration-200 hover:text-red-500"
                              : "font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-red-500"
                          }
                        >
                          Statistics
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          to="/blog"
                          aria-label="Blog"
                          title="Blog"
                          className={({ isActive }) =>
                            isActive
                              ? "font-medium tracking-wide text-blue-700 transition-colors duration-200 hover:text-red-500"
                              : "font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-red-500"
                          }
                        >
                          Blog
                        </NavLink>
                      </li>

                      <li className="pb-4">
                        <NavLink
                          to="/about"
                          aria-label="About"
                          title="About Us"
                          className={({ isActive }) =>
                            isActive
                              ? "font-medium tracking-wide text-blue-700 transition-colors duration-200 hover:text-red-500"
                              : "font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-red-500"
                          }
                        >
                          About Us
                        </NavLink>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
